import React from 'react';
import {createRoot} from 'react-dom/client';
import App from './App';

class OperatingInstructionsWebComponent extends HTMLElement {
	connectedCallback() {
		this.root = createRoot(this);

		this.root.render(<App />, this);
	}

	disconnectedCallback() {
		this.root.unmount();
		delete this.root;
	}
}

const ELEMENT_ID = 'mpm-operating-instructions';

if (!customElements.get(ELEMENT_ID)) {
	customElements.define(ELEMENT_ID, OperatingInstructionsWebComponent);
}
